import { css, StyleSheet } from 'aphrodite'
import PropTypes from 'prop-types'
import React from 'react'
import {
  COLOR_ERROR,
  COLOR_GRAY__600,
  COLOR_GRAY__800,
  COLOR_MUTED,
  COLOR_GREY_050,
  COLOR_WHITE,
  COLOR_GRAY__300,
} from '../../lib/colors'
import UIInputError from './UIInputError'

const UIInput = React.forwardRef(function UIInput(
  {
    label,
    placeholder,
    message,
    errorMessage,
    type = 'text',
    kind = 'normal',
    value = '',
    dynamicStyle,
    onChange,
    icon,
    onClick,
    hasMargin = true,
    ...props
  },
  ref
) {
  const isInError = !!errorMessage
  const hasMessage = !!message && !isInError
  const handleChange = (event) => {
    onChange(event.target.value)
  }

  return (
    <div className={css(styles[kind], dynamicStyle)}>
      <label className="uiInput">
        {!!label && (
          <>
            <span className={css(styles.label)}>{label}</span>
            <br />
          </>
        )}
        <div className={css(styles.iconContainer)}>
          {icon && <div className={css(styles.icon)}>{icon}</div>}

          <input
            type={type}
            className={css(
              icon
                ? styles.inputIcon
                : !hasMargin
                ? styles.hasMargin
                : styles.input,
              isInError && styles.inputError
            )}
            placeholder={placeholder}
            ref={ref}
            value={value}
            onChange={handleChange}
            onClick={onClick}
            {...props}
          />
        </div>
        {isInError && <UIInputError errorMessage={errorMessage} />}
        {hasMessage && <span className={css(styles.message)}>{message}</span>}
      </label>
    </div>
  )
})

const styles = StyleSheet.create({
  stack: {
    flexGrow: 1,
  },
  inputIcon: {
    width: '100%',
    padding: '16px 14px 14px 36px',
    border: '1px solid transparent',
    borderRadius: 5,
    backgroundColor: COLOR_WHITE,
    boxShadow: '0 1px 2px 0 #32324733',
    fontWeight: 500,
    fontSize: 15,
    color: COLOR_GRAY__800,
  },
  hasMargin: {
    margin: '0',
    width: '100%',
    padding: '14px 16px',
    border: '1px solid transparent',
    borderRadius: 5,
    backgroundColor: COLOR_GREY_050,
    boxShadow: '0 1px 2px 0 #32324733',
    fontWeight: 500,
    fontSize: 15,
    color: COLOR_GRAY__800,
  },
  input: {
    width: '100%',
    padding: '14px 16px',
    margin: '10px 0',
    border: '1px solid transparent',
    borderRadius: 5,
    fontWeight: 500,
    fontSize: 15,
    borderColor: COLOR_GRAY__300,
    color: COLOR_GRAY__800,
  },
  inputError: {
    borderColor: COLOR_ERROR,
    color: COLOR_ERROR,
  },
  message: {
    fontWeight: 400,
    fontSize: 11,
    color: COLOR_MUTED,
  },
  label: {
    display: 'inline-block',
    fontWeight: 400,
    fontSize: 14,
    color: COLOR_GRAY__600,
  },
  icon: {
    cursor: 'pointer',
    position: 'absolute',
    left: 10,
  },
  iconContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
})

UIInput.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf(['text', 'password', 'email', 'tel', 'date', 'file']),
  placeholder: PropTypes.string,
  message: PropTypes.string,
  errorMessage: PropTypes.string,
  kind: PropTypes.oneOf(['stack', null]),
  size: PropTypes.string,
  value: PropTypes.string,
  dynamicStyle: PropTypes.node,
  onChange: PropTypes.func,
  icon: PropTypes.node,
  onClick: PropTypes.func,
  hasMargin: PropTypes.bool,
}

export default UIInput
